export default __webpack_public_path__ + "static/media/a011-PPII-1.7d8802f6.svg";